export default "__VITE_ASSET__0IAb$OE___"